import { backgroundContainer } from './variables';

export const demonstrationYaloTheme = {
	//Container
	backgroundContainer: backgroundContainer
};
